module.exports = __webpack_public_path__ + "img/fake-user-2.44609315.png";